import React, { useEffect, useState } from "react";
import api, { fmtFCFA } from "@/lib/api";
import { DashboardShell, KpiCard } from "@/components/DashboardShell";
import { Button } from "@/components/ui/button";
import { PropertyFormDialog } from "@/components/PropertyFormDialog";
import { toast } from "sonner";
import { Plus, Trash2, Pencil, Building2 } from "lucide-react";

export default function OwnerDashboard() {
  const [tab, setTab] = useState("apercu");
  const [stats, setStats] = useState(null);
  const [props, setProps] = useState([]);

  const load = async () => {
    try {
      const [s, p] = await Promise.all([api.get("/owner/stats"), api.get("/owner/properties")]);
      setStats(s.data); setProps(p.data);
    } catch {}
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => { if (!window.confirm("Supprimer ce bien ?")) return; await api.delete(`/properties/${id}`); toast.success("Bien supprimé"); load(); };

  const tabs = [{ value: "apercu", label: "Aperçu" }, { value: "biens", label: `Mes biens (${props.length})` }];

  const AddDialog = (
    <PropertyFormDialog onSaved={load} trigger={<Button className="bg-gold text-navy hover:bg-gold-light font-semibold rounded-lg" data-testid="owner-add-btn"><Plus className="h-4 w-4 mr-1.5" /> Ajouter un bien</Button>} />
  );

  return (
    <DashboardShell title="Espace Propriétaire" subtitle="Pilotez vos biens, revenus et performances." tabs={tabs} active={tab} onTab={setTab}>
      {tab === "apercu" && stats && (
        <>
          <div className="flex justify-end mb-4">{AddDialog}</div>
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
            <KpiCard label="Nombre de biens" value={stats.properties} testid="kpi-props" />
            <KpiCard label="Revenus (mensuel)" value={fmtFCFA(stats.revenue)} accent testid="kpi-revenue" />
            <KpiCard label="Dépenses" value={fmtFCFA(stats.expenses)} testid="kpi-expenses" />
            <KpiCard label="Taux d'occupation" value={`${stats.occupancy}%`} testid="kpi-occupancy" />
            <KpiCard label="Demandes en cours" value={stats.requests} testid="kpi-requests" />
          </div>
          <div className="rounded-xl bg-white border border-black/5 p-6">
            <h3 className="font-serif text-xl font-semibold text-navy mb-4">Registre de mes biens</h3>
            {props.length === 0 ? <p className="text-slate-400 py-8 text-center">Aucun bien. Ajoutez votre premier bien.</p> : (
              <div className="space-y-3">
                {props.map((p) => (
                  <div key={p.id} className="flex items-center justify-between rounded-lg border p-4" data-testid={`owner-ledger-${p.reference}`}>
                    <div className="flex items-center gap-3">
                      <img src={p.images?.[0]} alt="" className="h-14 w-14 rounded-lg object-cover" />
                      <div><div className="font-medium text-navy">{p.title}</div><div className="text-xs text-slate-400">{p.reference} · {p.city}</div></div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="text-right"><div className="font-mono font-bold text-navy">{fmtFCFA(p.price)}</div><div className="text-xs text-gold">{p.status}</div></div>
                      <PropertyFormDialog property={p} onSaved={load} trigger={<Button variant="ghost" size="icon" className="text-navy hover:bg-navy/5" data-testid={`owner-ledger-edit-${p.reference}`}><Pencil className="h-4 w-4" /></Button>} />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}

      {tab === "biens" && (
        <>
          <div className="flex justify-end mb-4">{AddDialog}</div>
          {props.length === 0 ? <div className="rounded-xl bg-white border border-black/5 py-16 text-center text-slate-400"><Building2 className="mx-auto h-10 w-10 mb-3 opacity-40" />Aucun bien enregistré.</div> : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {props.map((p) => (
                <div key={p.id} className="rounded-xl bg-white border border-black/5 overflow-hidden" data-testid={`owner-prop-${p.reference}`}>
                  <img src={p.images?.[0]} alt="" className="aspect-[4/3] w-full object-cover" />
                  <div className="p-5">
                    <div className="font-mono text-xs text-gold">{p.reference}</div>
                    <h4 className="mt-1 font-semibold text-navy">{p.title}</h4>
                    <div className="mt-2 flex items-center justify-between">
                      <span className="font-mono font-bold text-navy">{fmtFCFA(p.price)}</span>
                      <div className="flex gap-1">
                        <PropertyFormDialog property={p} onSaved={load} trigger={<Button variant="ghost" size="icon" className="text-navy hover:bg-navy/5" data-testid={`owner-edit-${p.reference}`}><Pencil className="h-4 w-4" /></Button>} />
                        <Button onClick={() => del(p.id)} variant="ghost" size="icon" className="text-red-600 hover:bg-red-50" data-testid={`owner-del-${p.reference}`}><Trash2 className="h-4 w-4" /></Button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </DashboardShell>
  );
}
